var map = {
	"./18_PW.png": 32333,
	"./19PW.png": 80444,
	"./20PW.png": 57098,
	"./21PW.png": 78255,
	"components/Catalog/PW/img/glass/lp/lpPlusGold/18_PW.png": 32333,
	"components/Catalog/PW/img/glass/lp/lpPlusGold/19PW.png": 80444,
	"components/Catalog/PW/img/glass/lp/lpPlusGold/20PW.png": 57098,
	"components/Catalog/PW/img/glass/lp/lpPlusGold/21PW.png": 78255
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85916;